import uniqBy from 'lodash/uniqBy';

import { IMAGE } from '../../creative-assets/constants';

// eslint-disable-next-line import/prefer-default-export
export const getCreationRequirementOptions = availableCampaignLines => {
  const options = availableCampaignLines.map(({ product }) => {
    if (product.creativeRequirements.length > 0) {
      return product.creativeRequirements
        .filter(({ requirements }) => requirements.fileType === IMAGE)
        .map(data => ({
          label: `${product.code} - ${data.sizeType} (${data.requirements.imageWidth} x ${data.requirements.imageHeight})`,
          value: {
            label: `${product.code} - ${data.sizeType} (${data.requirements.imageWidth} x ${data.requirements.imageHeight})`,
            width: data.requirements.imageWidth,
            height: data.requirements.imageHeight,
          },
        }));
    }
    return null;
  });
  return uniqBy(options.filter(requirements => requirements).flat(), 'label');
};

// func to convert the image to a blob url for displaying it in the modal
export function toDataURL(url) {
  return new Promise(function getImageUrl(resolve) {
    const xhr = new XMLHttpRequest();
    xhr.onload = function onload() {
      const reader = new FileReader();
      reader.onloadend = function onloadend() {
        resolve(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  });
}
